import React, {useRef, useState} from "react";
import {Badge, Container, Row, Toast, Button} from "react-bootstrap";
import uuid from 'react-uuid';
import {host} from "../libs/webRTC"

let badges = {
    student_not_detected: {
        label: "danger",
        text: "student NOT detected"
    },
    student_not_looking_on_monitor: {
        label: "danger",
        text: "student NOT looking on monitor"
    },
    unknown_persons: {
        label: "warning",
        text: "Unknown persons detected"
    },
};



const Item = (props) => {
    const dialog = useRef(null);
    const [snapshot, setSnapshot] = useState(null);
    const [imageState, setImageState] = useState('loading');
    const [show, setShow] = useState(true);
    const toggleShow = () => setShow(!show);
    function setTime() {
        props.setViolation(Number(props.from));
    }

    function getImage() {
        setImageState('loading');
        setSnapshot(`${host}/links/snapshot/${props.token}/${props.source}?time=${encodeURIComponent(props.from)}`);
        dialog.current.showModal();
    }

    function parseTimeViolation(timeInfo) {
        let secInMin = String(parseInt(timeInfo%60));

        if(secInMin.length === 1){
            secInMin = '0' + secInMin;
        }

        return parseInt(timeInfo/60)+ ":"+ secInMin;
    }

    let parsedDuration = parseTimeViolation(props.duration);
    const parseFrom = parseTimeViolation(props.from)
    const parseTo = parseTimeViolation(props.to)

    return <><Toast onClose={toggleShow} show={show} animation={false}>
        <Toast.Header>
            <div className="watch-event-header">
                <span>{parseFrom} — {parseTo} · длительность {parsedDuration}</span>
                <div className="watch-event-actions">
                    <Button size="sm" onClick={setTime}>Перейти к событию</Button>
                    <Button size="sm" onClick={getImage}>Изображение</Button>
                </div>
            </div>
        </Toast.Header>
        <Toast.Body>
            <Container>
                <Row>
                    {
                        props.body[0].map(valueName => {
                            if (valueName === "student_not_detected" || valueName === "unknown_persons" || valueName === "student_not_looking_on_monitor")
                                return <Badge pill key={uuid()} variant={badges[valueName].label}>{badges[valueName].text}</Badge>
                            return <Badge pill key={uuid()} variant={"danger"}>{valueName}</Badge>
                        })
                    }
                </Row>
                <Row>
                    {
                        props.body[1].map(valueName => {
                                return <Badge pill key={uuid()} variant={"success"}>{valueName}</Badge>
                        })
                    }
                </Row>
            </Container>

        </Toast.Body>
    </Toast>
        <dialog ref={dialog} className="watch-snapshot" aria-label="Кадр события" onClose={() => setSnapshot(null)}>
            {snapshot && <>
                {imageState === 'loading' && <p role="status">Загрузка кадра…</p>}
                {imageState === 'error' && <p role="alert">Не удалось получить кадр. Проверьте доступ к записи или попробуйте ещё раз.</p>}
                <img src={snapshot} alt="Кадр в начале события" style={{display: imageState === 'ready' ? 'block' : 'none'}}
                    onLoad={() => setImageState('ready')} onError={() => setImageState('error')} />
            </>}
            <Button size="sm" onClick={() => { dialog.current.close(); setSnapshot(null); }}>Закрыть</Button>
        </dialog>
    </>
}

export default Item;
